import { render } from "./FloatingBottomBar.vue?vue&type=template&id=372de2b5&scoped=true"
import script from "./FloatingBottomBar.vue?vue&type=script&lang=js"
export * from "./FloatingBottomBar.vue?vue&type=script&lang=js"

import "./FloatingBottomBar.vue?vue&type=style&index=0&id=372de2b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372de2b5"]])

export default __exports__